export enum FEEDBACK_TYPE {
  DASHBOARD_FEEDBACK = 'DASHBOARD_FEEDBACK',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  GENERAL_ENQUIRY = 'GENERAL_ENQUIRY',
}

export const feedbackOptions = [
  {
    label: 'Dashboard Feedback',
    value: FEEDBACK_TYPE.DASHBOARD_FEEDBACK,
  },
  {
    label: 'Request New Feature',
    value: FEEDBACK_TYPE.FEATURE_REQUEST,
  },
  {
    label: 'General Enquiry',
    value: FEEDBACK_TYPE.GENERAL_ENQUIRY,
  },
];

export const MAX_TOTAL_SIZE_MB = 50;
export const MAX_IMAGE_COUNT = 3;
export const MAX_VIDEO_COUNT = 1;
export const MAX_PDF_COUNT = 2;
export const MAX_FILE_COUNT = 5;
export const MAX_FEEDBACK_LENGTH = 1000;
